import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAPurity,
  getPurity,
  resetState,
} from "../features/purity/puritySlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Purity",
    dataIndex: "name",
    sorter: (a, b) => a.name - b.name,
  },
  {
    title: "Metal Type",
    dataIndex: "type",
    sorter: (a, b) => a.name - b.name,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Puritylist = () => {
  const [open, setOpen] = useState(false);
  const [purityId, setpurityId] = useState("");
   const [loading, setLoading] = useState(true);

  const showModal = (e) => {
    setOpen(true);
    setpurityId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        await dispatch(resetState());
        await dispatch(getPurity());
        setLoading(false);
      };
  
      fetchData();
    }, [dispatch]);

  const purityState = useSelector((state) => state.purity.Purity);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const data1 = purityState.map((purity, index) => ({
    key: index + 1,
    name: purity.product_purity,
    type: purity.metal_type?.metal_name || "N/A",
    action: (
      <>
        <Link
          to={`/admin/purity/${purity._id}`}
          className=" fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(purity._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deletePurity = (e) => {
    dispatch(deleteAPurity(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getPurity());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Purity</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deletePurity(purityId);
        }}
        title="Are you sure you want to delete this Purity?"
      />
    </div>
  );
};

export default Puritylist;